import React from 'react';
import PropTypes from 'prop-types';
import {
  Box, Button, IconButton, MenuItem, TextField, Checkbox, FormControlLabel, Divider,
} from '@mui/material';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import AddIcon from '@mui/icons-material/Add';

export function novoChequeDetalhe() {
  return {
    idBanco: { value: '', error: false, errorMessage: '' },
    serChequeTerceiro: { value: false, error: false, errorMessage: '' },
    numeroAgencia: { value: '', error: false, errorMessage: '' },
    numeroConta: { value: '', error: false, errorMessage: '' },
    dac: { value: '', error: false, errorMessage: '' },
    numeroCheque: { value: '', error: false, errorMessage: '' },
    valor: { value: '', error: false, errorMessage: '' },
  };
}

/**
 * Sub-formulário de detalhes de cheque — port de `DetalheCheque.jsx`/
 * `ChequeCampos.jsx` reais. Um único cheque OU múltiplos (por isso é lista),
 * cada campo no shape `{value, error, errorMessage}` — mesmo shape que
 * `passoTresController.makePayloadGerarAcordo` já espera (`chequeDetalhe`),
 * herdado desde a Etapa 4 (`buildParcelas`, passthrough do valor cru da API).
 */
export default function DetalheCheque({ chequesDetalhes, onChange, bancosOptions }) {
  const atualizarCampo = (indice, campo, valor) => {
    const proximo = chequesDetalhes.map((cheque, i) => (i === indice
      ? { ...cheque, [campo]: { value: valor, error: false, errorMessage: '' } }
      : cheque));
    onChange(proximo);
  };

  const adicionarCheque = () => {
    onChange([...chequesDetalhes, novoChequeDetalhe()]);
  };

  const removerCheque = (indice) => {
    onChange(chequesDetalhes.filter((_, i) => i !== indice));
  };

  return (
    <Box>
      {chequesDetalhes.map((cheque, indice) => (
        // eslint-disable-next-line react/no-array-index-key
        <Box key={indice} sx={{ mb: 2 }}>
          <Box sx={{
            display: 'flex', gap: 2, flexWrap: 'wrap', alignItems: 'flex-start',
          }}
          >
            <TextField
              select
              label="Banco"
              value={cheque.idBanco.value}
              onChange={e => atualizarCampo(indice, 'idBanco', e.target.value)}
              error={cheque.idBanco.error}
              helperText={cheque.idBanco.errorMessage}
              size="small"
              sx={{ minWidth: 200 }}
            >
              {bancosOptions.map(opcao => (
                <MenuItem key={opcao.id} value={opcao.id}>{opcao.value}</MenuItem>
              ))}
            </TextField>
            <TextField
              label="Agência"
              value={cheque.numeroAgencia.value}
              onChange={e => atualizarCampo(indice, 'numeroAgencia', e.target.value)}
              error={cheque.numeroAgencia.error}
              helperText={cheque.numeroAgencia.errorMessage}
              size="small"
              inputProps={{ maxLength: 5 }}
            />
            <TextField
              label="Número da Conta"
              value={cheque.numeroConta.value}
              onChange={e => atualizarCampo(indice, 'numeroConta', e.target.value)}
              error={cheque.numeroConta.error}
              helperText={cheque.numeroConta.errorMessage}
              size="small"
              inputProps={{ maxLength: 10 }}
            />
            <TextField
              label="DAC"
              value={cheque.dac.value}
              onChange={e => atualizarCampo(indice, 'dac', e.target.value)}
              size="small"
              inputProps={{ maxLength: 1 }}
              sx={{ width: 80 }}
            />
            <TextField
              label="Número do Cheque"
              value={cheque.numeroCheque.value}
              onChange={e => atualizarCampo(indice, 'numeroCheque', e.target.value)}
              error={cheque.numeroCheque.error}
              helperText={cheque.numeroCheque.errorMessage}
              size="small"
              inputProps={{ maxLength: 10 }}
            />
            <TextField
              type="number"
              label="Valor"
              value={cheque.valor.value}
              onChange={e => atualizarCampo(indice, 'valor', e.target.value)}
              error={cheque.valor.error}
              helperText={cheque.valor.errorMessage}
              size="small"
              inputProps={{ min: 0, step: 0.01 }}
            />
            <FormControlLabel
              control={(
                <Checkbox
                  checked={Boolean(cheque.serChequeTerceiro.value)}
                  onChange={e => atualizarCampo(indice, 'serChequeTerceiro', e.target.checked)}
                />
              )}
              label="Cheque de Terceiros"
            />
            <IconButton onClick={() => removerCheque(indice)} aria-label="Excluir cheque">
              <DeleteOutlineIcon />
            </IconButton>
          </Box>
          {indice < chequesDetalhes.length - 1 && <Divider sx={{ mt: 2 }} />}
        </Box>
      ))}
      <Button startIcon={<AddIcon />} onClick={adicionarCheque}>Cadastrar Cheques</Button>
    </Box>
  );
}

DetalheCheque.propTypes = {
  chequesDetalhes: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  bancosOptions: PropTypes.array,
};

DetalheCheque.defaultProps = {
  bancosOptions: [],
};
